if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // ギフトラッピングの選択状態を document から取得（form外でも可）
        const selectedGiftOption = document.querySelector('[name="properties[ギフトラッピング]"]:checked');
        const giftWrapSelected = selectedGiftOption?.value === 'あり';
        const GIFT_WRAP_VARIANT_ID = '41573644763230'; // ←ここは実際のIDに差し替え
        const quantity = Number(formData.get('quantity')) || 1;

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          // ギフト商品を追加
          if (giftWrapSelected) {
            const giftResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: GIFT_WRAP_VARIANT_ID,
                quantity: quantity
              })
            });

            if (!giftResponse.ok) {
              const errorData = await giftResponse.json();
              console.error('ギフト商品追加エラー:', errorData);
              return;
            }

            // カートドロワー更新
            const res = await fetch(`/cart?sections=cart-drawer&timestamp=${Date.now()}`);
            const html = await res.json();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html['cart-drawer'], 'text/html');

            const newDrawer = doc.querySelector('cart-drawer');
            const currentDrawer = document.querySelector('cart-drawer');

            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
              if (typeof currentDrawer.open === 'function') {
                currentDrawer.open();
              } else {
                currentDrawer.classList.add('active');
              }
            }
          } else {
            // 通常の商品だけの場合
            this.cart.renderContents(response);
            if (typeof this.cart.open === 'function') this.cart.open();
          }

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                  if (typeof this.cart.open === 'function') this.cart.open();
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          }

        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}